var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fl"},[_c('img',{attrs:{"src":_vm.img_404,"alt":""}}),_c('br'),_c('a',{attrs:{"href":"/"}},[_vm._v("返回首页")])])}
var staticRenderFns = []

export { render, staticRenderFns }